<template>
  <div class="asd20-language-translation">
    <asd20-loader size="sm" v-show="_languageLoading"></asd20-loader>
    <asd20-select-input
      v-show="languageOptions"
      v-model="_languageCode"
      :label="label"
      hide-label
      item-label="label"
      item-value="code"
      icon="translate"
      :items="languageOptions"
      :reversed="reversed"
    />
  </div>
</template>

<script>
import Asd20SelectInput from '../../atoms/Asd20SelectInput'
import Asd20Loader from '../../molecules/Asd20Loader'
import languages from '../../../data/language-translation-options.json'
import globalPropMixinFactory from '../../../mixins/globalPropMixinFactory.js'
import hasLoaderMixin from '../../../mixins/hasLoaderMixin.js'

export default {
  name: 'Asd20LanguageTranslation',
  components: {
    Asd20SelectInput,
    Asd20Loader,
  },
  mixins: [
    globalPropMixinFactory('languageCode', {
      type: String,
      default: 'en',
    }),
    hasLoaderMixin('languageLoading'),
  ],
  props: {
    label: { type: String, default: 'Translate this page' },
    reversed: { type: Boolean, default: false },
  },
  data: () => ({
    // Store the currently selected langauge
    // in component state
    languages,
  }),
  computed: {
    languageOptions() {
      // Create an array from keys
      return (
        Object.keys(languages.translation)
          // Map keys to new option objects
          .map(k => ({
            // Set the id to the key/language code
            code: k,
            // Use the key to get a value, and then
            // part of it to get the label
            label: `${languages.translation[k].name} (${languages.translation[k].nativeName})`,
            ...languages.translation[k],
          }))

          // Sort by preferred, then by code
          // that way the native preferred language
          // is always on top
          .sort((a, b) => {
            // if (this.getPreferredLanguageCode().includes(a.code)) return -1 // Move up
            if (a.name < b.name) return -1 // Move up
            if (a.name > b.name) return 1 // Move down
            return 0 // Leave where it is
          })
      )
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/_variables.scss';
.asd20-language-translation {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 0;
  height: 2.75rem;
  &::v-deep .asd20-loader {
    // height: 48px;
    width: 36px;
    position: inherit;
    // margin-bottom: space(0.5);
    background: transparent;
  }
  &::v-deep .asd20-select-input {
    margin-bottom: 0;
    &__overlay-label ::after {
      margin-right: space(1);
    }
  }
}
</style>
